import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@/redux/hooks';
import { QueriesKeys } from '../queriesKeys';
import { walletApi } from './wallet.api';

export const useWalletMeQuery = () => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    queryKey: [QueriesKeys.wallet],
    queryFn: () => walletApi.getMe(),
    enabled: userSession,
  });
};

export const useWalletMeDetailsQuery = () => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    queryKey: [QueriesKeys.wallet, 'details'],
    queryFn: () => walletApi.getMeDetails(),
    enabled: userSession,
  });
};

export const useWalletTransactionsQuery = (limit = 10, page = 1) => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    queryKey: [QueriesKeys.transactions, 'transactions', limit, page],
    queryFn: () => walletApi.getTransactions({ limit, page, sort: { updatedAt: 'desc' } }),
    enabled: userSession,
    placeholderData: keepPreviousData,
  });
};
